<template>
  <div>

    <vue-gauge :refid="'_' + Math.random().toString(36).substr(2, 9)" :options="myOptions" />

  </div>
</template>
  
<script>
import VueGauge from "vue-gauge";
export default {
  components: { VueGauge },
  props: {
    title: String,
    value: String,
    rangeLabel: String,
    arcLabels: Array
  },
  data() {
    return {
      myOptions: {
        //chartWidth: window.innerWidth / 2,
        //chartWidth: 250 ,
        needleValue: (this.value / this.rangeLabel * 100).toString(),
        //needleColor: "black",

        arcDelimiters: [15 / 0.6, 40 / 0.6],
        arcColors: ["rgb(255,84,84)", "rgb(239,214,19)", "rgb(61,204,91)"],
        //arcLabels: ["15", "40"],
        rangeLabel: ["0", (this.rangeLabel / 1000).toString() + 'K'],
        centralLabel: this.value,

        // rangeLabelFontSize: 14,
      },
    };
  },
  mounted() {

  },
};
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
  